import Vue from 'vue';
import Router from 'vue-router';
import store from '../config/store'
import MyInfo from "../config/MyInfo";
import Perference from "../config/perference";
import Splash from '@/components/contents/auth/Splash';
import Login from '@/components/contents/auth/Login';
import SignupInfo from '@/components/contents/auth/SignupInfo';
import SignupQuiz from '@/components/contents/auth/SignupQuiz';
import Home from '@/components/contents/main/home/Home';
import Interest from '@/components/contents/main/interest/Interest';
import SiteNotify from '@/components/contents/main/interest/SiteNotify';
import SiteDetail from '@/components/contents/main/interest/SiteDetail';
import Inquire from '@/components/contents/main/more/Inquire';
import RegGeneralOrNewOpenSite1 from '@/components/contents/main/more/RegGeneralOrNewOpenSite1';
import RegNewOpenSite2 from '@/components/contents/main/more/RegNewOpenSite2';
import MonthlySale from '@/components/contents/main/home/MonthlySale';

import AdminLogin from '@/components/contents/main/admin/AdminLogin';
import AdminAd from '@/components/contents/main/admin/AdminAd';
import AdminPoint from '@/components/contents/main/admin/AdminPoint';
import AdminSaleReq from '@/components/contents/main/admin/AdminSaleReq';
import AdminPeriod from '@/components/contents/main/admin/AdminPeriod';
import AdminMember from '@/components/contents/main/admin/AdminMember';
import AdminMemberDb from '../components/contents/main/admin/AdminMemberDb';
import AdminWrite from '../components/contents/main/admin/AdminWrite';
import AdminWriteSale from "../components/contents/main/admin/AdminWriteSale";
import AdminWriteNotice from "../components/contents/main/admin/AdminWriteNotice";
import AdminWriteCommunity from "../components/contents/main/admin/AdminWriteCommunity";
import AdminManage from "../components/contents/main/admin/AdminManage";
import AdminAccept from "../components/contents/main/admin/AdminAccept";
import AdminConfirm from "../components/contents/main/admin/AdminConfirm";
import AdminInfo from "../components/contents/main/admin/AdminInfo";
import AdminSite from "../components/contents/main/admin/AdminSite";


import Map from '@/components/contents/main/map/Map';
import More from "../components/contents/main/more/More";
import Notify from "../components/contents/main/notify/Notify";
import TodayNotify from "../components/contents/main/notify/TodayNotify";
import ModifyNotification from "../components/contents/main/notify/ModifyNotification";
import AutoNotification from "../components/contents/main/notify/AutoNotification";
import SendNotification from "../components/contents/main/notify/SendNotification";
import Community from "../components/contents/main/community/Community";
import RegSite from "../components/contents/main/more/RegSite";
import SiteReport from "../components/contents/main/site_report/SiteReport";
import SaleList from "../components/contents/main/sale/SaleList";
import UnregisteredSite from "../components/contents/main/more/UnregisteredSite";
import AdminSaleLogOld from "../components/contents/main/admin/AdminSaleLogOld";
import ShareSite from "../components/contents/main/ShareSite";
import AdminWriteUpdateSale from "../components/contents/main/admin/AdminWriteUpdateSale";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: '/',
      component: Splash
    },
    {
      path: '/Login',
      component: Login
    },
    {
      path: '/SignupInfo',
      component: SignupInfo
    },
    {
      path: '/SignupQuiz',
      component: SignupQuiz
    },
    {
      path: '/Home',
      component: Home,
      meta: {
        auth: true
      }
    },
    {
      path: '/Interest',
      component: Interest,
      meta: {
        auth: true
      }
    },
    {
      path: '/SiteReport',
      component: SiteReport,
      meta: {
        auth: true
      }
    },
    {
      path: '/Community',
      component: Community,
      meta: {
        auth: true
      }
    },
    {
      name: 'SiteDetail',
      path: '/SiteDetail',
      component: SiteDetail,
      meta: {
        auth: true
      }
    },
    {
      path: '/Inquire',
      component: Inquire,
    },
    {
      path: '/ShareSite/:site_idx',
      component: ShareSite,
      meta: {
        auth: true
      },
    },
    {
      path: '/RegSite',
      component: RegSite,
      meta: {
        auth: true
      },
      children: [
        {
          name: 'RegSite1',
          path: 'step1/:type(New|General)',
          component: RegGeneralOrNewOpenSite1,
        },
        {
          name: 'RegNewOpenSite2',
          path: 'step2',
          component: RegNewOpenSite2,
        },
      ],
    },
    {
      name: 'UnregisteredSite',
      path: '/UnregisteredSite',
      component: UnregisteredSite,
      meta: {
        auth: true
      }
    },
    {
      path: '/SaleList',
      component: SaleList,
      meta: {
        auth: true
      }
    },
    {
      path: '/SiteNotify',
      component: SiteNotify,
      meta: {
        auth: true
      }
    },
    {
      path: '/MonthlySale',
      component: MonthlySale,
      meta: {
        auth: true
      }
    }, {
      path: '/Map',
      component: Map,
      meta: {
        auth: true
      }
    },
    {
      path: '/More',
      component: More,
      meta: {
        auth: true
      }
    },
    {
      path: '/notify',
      component: Notify,
      meta: {
        auth: true
      },
    },
    {
      path: '/notify/today',
      component: TodayNotify,
      meta: {
        auth: true
      },
    },
    {
      path: '/admin/ads',
      component: AdminAd,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/point',
      component: AdminPoint,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/period',
      component: AdminPeriod,
      meta: {
        auth: true
      }
    },
    // {
    //   path: '/admin/sale',
    //   component: AdminSaleReq,
    //   meta: {
    //     auth: true
    //   }
    // },
    {
      path: '/admin/salelog',
      component: AdminSaleLogOld,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/member',
      component: AdminMember,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/db',
      component: AdminMemberDb,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/manage',
      component: AdminManage,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/site',
      component: AdminSite,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/write',
      component: AdminWrite,
      meta: {
        auth: true
      },
      children: [
        {
          path: 'update_sale',
          component: AdminWriteUpdateSale,
        },
        {
          path: 'sale',
          component: AdminWriteSale,
        },
        {
          path: 'notice',
          component: AdminWriteNotice,
        },
        {
          path: 'community',
          component: AdminWriteCommunity,
        },
      ]
    },
    {
      path: '/admin/login',
      component: AdminLogin,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/info',
      component: AdminInfo,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/accept',
      component: AdminAccept,
      meta: {
        auth: true
      }
    },
    {
      path: '/admin/confirm',
      component: AdminConfirm,
      meta: {
        auth: true
      }
    },
  ],
  mode: 'history',
});


const isAuthenticated = () => {
  return (MyInfo.isValid() && MyInfo.accessToken != '');
};

const isAdmin = () => {
  return (isAuthenticated() && MyInfo.isAdmin());
};

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (isAuthenticated())
      next();
    else {
      let uid = Perference.getInt('uid');
      let token = Perference.getString('accessToken');
      if (uid > 0 && token != '') {
        MyInfo.loadInfo();
        next();
      } else
        next('/Login');
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js